import React, { useState } from "react";
import { BiLoaderCircle } from "react-icons/bi";
import { HiMenuAlt3, HiOutlineLogout } from "react-icons/hi";
import { NavLink, useNavigate } from "react-router-dom";
import imageProfile from '../../assets/face8.png';
import useIsAuthenticate from "../../hook/useIsAuthentificated";
import { navbarItems } from "../Utils/UtilsAcceuilPage";
import MonBouton from "../Utils/design-system/buttons/MonBouton";
// import { PiShareBold } from "react-icons/pi";
import { BiX } from "react-icons/bi";
import { FaChevronDown } from "react-icons/fa6";
import { PiArrowBendDoubleUpRightBold } from "react-icons/pi";
import { useSelector } from "react-redux";
import { ProjectsEndpoints } from "../../Routes/api/Endpoints";
import { apiUrlImg } from "../../Routes/api/global_vars";
import { CLIENT_DASHBOARDS, CLIENT_DASHBOARDS_DASHBOARD, PROJECTS } from "../../Routes/navigation/navigationPaths";
import { useAppContext } from "../../context/AppContext";
import { selectData } from "../../redux/features/userSliceWithTokenValidation";
import { useFetchCategoriesProjetsQuery, useLogoutUserMutation } from "../../services/auth-services/AuthService";

export const NavBarPageAccueil = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isOpenProfile, setIsOpenProfile] = useState(false);
  const isAuthenticated = useIsAuthenticate();
  const navigate = useNavigate();
  const [logout] = useLogoutUserMutation();
  const { projets, apiUrlImg } = useAppContext()
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const userData = useSelector((state) => state.user.data);
  const user = useSelector(selectData);
  const { data: categoriesProjets } = useFetchCategoriesProjetsQuery(
    ProjectsEndpoints.categoriesProjets
  );

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    if (value.trim() === "") {
      setFilteredSuggestions([]);
      return;
    }

    const searchResults = {
      projets: [],
      categories: [],
      services: [],
      sousServices: []
    };

    // Recherche dans les projets
    if (projets) {
      searchResults.projets = projets.filter((project) =>
        project.titre.toLowerCase().includes(value.toLowerCase())
      );
    }

    // Recherche dans les catégories, services et sous-services
    categoriesProjets?.forEach(category => {
      // Recherche dans les catégories
      if (category.nom_categorie.toLowerCase().includes(value.toLowerCase())) {
        searchResults.categories.push(category);
      }

      category.services?.forEach(service => {
        if (service.nom_service.toLowerCase().includes(value.toLowerCase())) {
          searchResults.services.push({
            ...service,
            categoryId: category.id,
            categoryName: category.nom_categorie
          });
        }

        service.sous_services?.forEach(sousService => {
          if (sousService.nom_sous_service.toLowerCase().includes(value.toLowerCase())) {
            searchResults.sousServices.push({
              ...sousService,
              serviceName: service.nom_service,
              categoryId: category.id,
              categoryName: category.nom_categorie
            });
          }
        });
      });
    });

    setFilteredSuggestions(searchResults);
  };

  const handleSelectItem = (type, item) => {
    setSearchTerm("");
    setFilteredSuggestions([]);

    switch (type) {
      case 'projet':
        navigate(`/projets/${item.slug}`);
        break;
      case 'categorie':
        navigate(`/projets?category=${item.id}`);
        break;
      case 'service':
        navigate(`/projets?category=${item.categoryId}&service=${encodeURIComponent(item.nom_service)}`);
        break;
      case 'sousService':
        navigate(`/projets?category=${item.categoryId}&service=${encodeURIComponent(item.serviceName)}&sousService=${encodeURIComponent(item.nom_sous_service)}`);
        break;
    }
  };

  const LogOut = () => {
    logout();
    navigate("/connexion");
  };
  const toggleMenu = () => {
    setIsOpenProfile(!isOpenProfile);
  };

  return (
    <nav className="max-md:w-[90%] w-[90%] h-[98%] relative ">
      {/* Navbar en mode normal */}
      <div className=" mx-auto flex items-center md:justify-between max-sm:pt-1 max-w-screen-xl headerAcceuil font-sans h-full">
        {/* Logo */}
        <div
          className="flex items-center space-x-2 cursor-pointer"
          onClick={() => navigate("/")}
        >
          <BiLoaderCircle className="text-[26px] text-orange" />
          <span className={`text-[17px] max-lg:text-sm max-lg:font-normal font-[500] text-vrt font-sans self-center max-lg:self whitespace-nowrap`}>Bakeli Work</span>
        </div>
        <div className="w-[32%] max-md:hidden max-lg:w-[28%] flex justify-end">
          <label
            className={`input input-bordered max-lg:text-xs flex items-center gap-2 !bg-grisrel text-black h-7 rounded-full focus:!outline-none !outline-none !shadow-none text-sm font-poppins !border-none !w-[94%] !max-md:w-full relative`}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              className="lucide lucide-search">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.3-4.3" />
            </svg>
            <input
              type="text"
              className="grow !bg-transparent"
              placeholder="Rechercher"
              value={searchTerm}
              onChange={handleSearch}
            />
            {searchTerm && (
              <BiX className="cursor-pointer" onClick={() => handleSearch({ target: { value: "" } })} />
            )}
            {(filteredSuggestions?.projets?.length > 0 ||
              filteredSuggestions?.categories?.length > 0 ||
              filteredSuggestions?.services?.length > 0 ||
              filteredSuggestions?.sousServices?.length > 0) && (
                <div className="absolute w-full top-6 left-0 bg-white text-noirel border border-gray-300 rounded-md mt-2 max-h-80 overflow-y-auto shadow-md z-10">
                  {filteredSuggestions.projets.length > 0 && (
                    <>
                      <div className="px-3 py-2 text-xs font-semibold text-gray-500">Projets</div>
                      {filteredSuggestions.projets.map((project) => (
                        <li
                          key={project.slug}
                          className="px-3 flex justify-between items-center py-2 cursor-pointer text-noirel hover:bg-gray-200"
                          onClick={() => handleSelectItem('projet', project)}
                        >
                          <div className='flex gap-3'>
                            <span className="bg-gray-200 p-1 rounded-full">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                className="lucide lucide-search"
                              >
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                              </svg>
                            </span>
                            {project.titre}
                          </div>
                          <img src={`${apiUrlImg}/${project?.image}`} className="w-12 object-cover rounded h-8"
                            alt="img" />
                        </li>
                      ))}
                    </>
                  )}

                  {filteredSuggestions.categories.length > 0 && (
                    <>
                      <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-t">Catégories</div>
                      {filteredSuggestions.categories.map((category) => (
                        <li
                          key={category.id}
                          className="px-3 flex items-center gap-3 py-2 cursor-pointer text-noirel hover:bg-gray-200"
                          onClick={() => handleSelectItem('categorie', category)}
                        >
                          <span className="bg-gray-200 p-1 rounded-full">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M4 20h16a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2h-7.93a2 2 0 0 1-1.66-.9l-.82-1.2A2 2 0 0 0 7.93 3H4a2 2 0 0 0-2 2v13c0 1.1.9 2 2 2Z" />
                            </svg>
                          </span>
                          {category.nom_categorie}
                        </li>
                      ))}
                    </>
                  )}

                  {filteredSuggestions.services.length > 0 && (
                    <>
                      <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-t">Services</div>
                      {filteredSuggestions.services.map((service) => (
                        <li
                          key={service.id}
                          className="px-3 flex items-center gap-3 py-2 cursor-pointer text-noirel hover:bg-gray-200"
                          onClick={() => handleSelectItem('service', service)}
                        >
                          <span className="bg-gray-200 p-1 rounded-full">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M3 9h18v10a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V9Z" /><path d="M3 9V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4" />
                            </svg>
                          </span>
                          {service.nom_service}
                        </li>
                      ))}
                    </>
                  )}

                  {filteredSuggestions.sousServices.length > 0 && (
                    <>
                      <div className="px-3 py-2 text-xs font-semibold text-gray-500 border-t">Sous-services</div>
                      {filteredSuggestions.sousServices.map((sousService) => (
                        <li
                          key={sousService.id}
                          className="px-3 flex items-center gap-3 py-2 cursor-pointer text-noirel hover:bg-gray-200"
                          onClick={() => handleSelectItem('sousService', sousService)}
                        >
                          <span className="bg-gray-200 p-1 rounded-full">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                              <path d="M14 4c0-1.1-.9-2-2-2s-2 .9-2 2" /><path d="M20 7H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2Z" />
                            </svg>
                          </span>
                          {sousService.nom_sous_service}
                        </li>
                      ))}
                    </>
                  )}
                </div>
              )}
          </label>
        </div>

        {/* Menu en mode normal */}
        <div className="hidden md:flex items-center space-x-4 relative">
          {navbarItems.map((item, index) => (
            <NavLink
              key={index}
              to={item.path}
              className={({ isActive }) =>
                `relative inline-block px-2 py-1 text-noirel font-medium max-2xl:text-[15.5px] max-xl:text-xs max-lg:text-[10px] font-mandali ${isActive
                  ? "after:content-[''] after:absolute after:left-1/2 after:transform after:-translate-x-1/2 after:bottom-0 after:w-[40%] after:h-[1.5px] after:bg-orange"
                  : ""
                }`
              }
            >
              {item.text}
            </NavLink>
          ))}
          {isAuthenticated ? (
            <div className="flex items-center space-x-4 ">
              <button
                type="button"
                className="flex text-sm rounded-badge bg-white space-x-2 border p-1 md:me-0 items-center"
                id="user-menu-button"
                aria-expanded={isOpenProfile}
                onClick={toggleMenu}
                data-dropdown-placement="bottom"
              >
                {!user?.profile ? (
                  <img
                    src={imageProfile}
                    alt="userProfile"
                    className="w-10 h-10 rounded-full"
                  />
                ) : (
                  <img
                    src={`${apiUrlImg}/${user?.profile}`}
                    alt="userProfile"
                    className="w-9 h-9 rounded-full object-cover"
                  />
                )}
                {/* <FaChevronDown className="ml-1" size={11} /> */}
              </button>
              {/* <MonBouton
                action={LogOut}
                children="Déconnexion"
                couleurFond="bg-orange text-white text-sm"
                bordure="px-4 py-2 rounded-full"
              /> */}
              <div
                className={`!z-[10000] ${isOpenProfile ? "block" : "hidden"
                  } my-4 text-base list-none bg-white rounded-lg shadow-md absolute top-full right-0`}
                id="user-dropdown"
              >
                <div className="px-3 py-3 border-b">
                  <span className="block text-sm text-gray-900">
                    {user?.name}
                  </span>
                  <span className="block text-xs text-gray-500 truncate dark:text-gray-400">
                    {user?.email}
                  </span>
                </div>
                <ul className="py-2" aria-labelledby="user-menu-button">
                  <li
                    className="flex items-center gap-2 cursor-pointer p-3 hover:bg-gray-200"
                    onClick={() => navigate(`/${CLIENT_DASHBOARDS}${PROJECTS}`)}
                  >
                    <PiArrowBendDoubleUpRightBold size="18px" />
                    <span className="text-xs text-black/70">Mon Dashboard</span>
                  </li>
                  <li
                    className="flex items-center gap-2 cursor-pointer p-3 hover:bg-gray-200"
                    onClick={LogOut}
                  >
                    <HiOutlineLogout size="18px" />
                    <span className="text-xs text-black/70">Déconnexion</span>
                  </li>
                </ul>
              </div>
            </div>
          ) : (
            <div className="flex items-center space-x-4">
              <MonBouton
                action={() => navigate("/soumettre-projet")}
                children="Soumettre un projet"
                couleurFond=" text-grayrel text-sm max-xl:text-xs max-lg:text-[10px] text-blc"
              />
              <MonBouton
                action={() => navigate("/connexion")}
                children="Se connecter"
                couleurFond={
                  isAuthenticated
                    ? "bg-orange text-white opacity-60 text-nowrap"
                    : "bg-orange text-white text-sm max-xl:text-xs max-lg:text-[8px] text-blc  text-nowrap"
                }
                bordure={
                  "px-7 max-lg:px-2 py-2 max-lg:py-1 rounded-full justify-center max-w-max"
                }
              />
            </div>
          )}
        </div>

        {/* Bouton menu responsive */}
        <button
          className="inline-flex items-center p-1 w-8 h-8 justify-center ml-auto text-sm text-gray-500 rounded-sm md:hidden hover:bg-gray-100 focus:outline-none dark:text-gray-400 "
          onClick={() => setIsMenuOpen(true)}
        >
          <HiMenuAlt3 className="w-11 h-11" />
        </button>
      </div>

      {/* Offcanvas en mode responsive */}
      {isMenuOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50">
          <div className="absolute top-0 right-0 w-64 h-full bg-white shadow-lg p-4 flex flex-col ">
            <div className="flex items-center mb-4 justify-between">
              <button
                className="text-grayrel"
                onClick={() => setIsMenuOpen(false)}
              >
                <HiOutlineLogout size={30} />
              </button>
              <div
                className="flex items-center space-x-2 cursor-pointer"
                onClick={() => navigate("/")}>
                <BiLoaderCircle className="text-[26px] text-orange" />
                <span className={`text-[17px] max-lg:text-sm max-lg:font-normal font-[500] text-vrt font-sans self-center max-lg:self whitespace-nowrap`}>Bakeli Work</span>
              </div>
            </div>
            <ul className="space-y-4">
              {navbarItems.map((item, index) => (
                <li key={index}>
                  <NavLink
                    to={item.path}
                    className={({ isActive }) =>
                      `block text-sm font-medium ${isActive ? "text-orange" : "text-gray-600"
                      }`
                    }
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.text}
                  </NavLink>
                </li>
              ))}
            </ul>
            {isAuthenticated ? (
              <>
                <li>
                  <button
                    className="w-full text-left text-sm text-gray-700"
                    onClick={() => {
                      setIsMenuOpen(false);
                    }}
                  >
                    Mon profil
                  </button>
                </li>
                <li>
                  <MonBouton
                    action={() => {
                      LogOut();
                      setIsMenuOpen(false);
                    }}
                    children="Déconnexion"
                    couleurFond="bg-orange text-white text-sm"
                    bordure="w-full px-4 py-2 rounded-full"
                  />
                </li>
              </>
            ) : (
              <div className="flex flex-col space-y-4 mt-auto">
                <li className="text-center list-none">
                  <MonBouton
                    action={() => {
                      navigate("/soumettre-projet");
                      setIsMenuOpen(false);
                    }}
                    children="Soumettre un projet"
                    couleurFond="bg-gray-100 text-gray-700 text-sm"
                    bordure="w-full px-4 py-2 rounded-full justify-center"
                  />
                </li>
                <li className="text-center list-none">
                  <MonBouton
                    action={() => {
                      navigate("/connexion");
                      setIsMenuOpen(false);
                    }}
                    children="Se connecter"
                    couleurFond={
                      isAuthenticated
                        ? "bg-orange text-white opacity-60 text-nowrap "
                        : "bg-orange text-white text-sm   text-blc  text-nowrap"
                    }
                    bordure={
                      "w-full px-4 py-2  rounded-full justify-center"
                    }
                  />
                </li>
              </div>
            )}
          </div>
        </div>
      )}
    </nav>
  );
};
